let socials = [
    { 
        title: 'LinkedIn',
        img: require('@/assets/socials/linkedin.png'),
        link: 'https://www.linkedin.com/in/arthurmirandadev/'
    },
    {
        title: 'Instagram',
        img: require('@/assets/socials/instagram.png'),
        link: 'https://www.instagram.com/arthurmirandadev/'
    },
    { 
        title: 'GitHub',
        img: require('@/assets/socials/github.png'),
        link: 'https://github.com/devarthurmiranda'
    },

];

export default socials;